import {AfterContentChecked, ChangeDetectorRef, Component, forwardRef, Input, OnInit} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { setupUntilDestroy , formControlErrorKeys, formControlErrorMessage, noSpaceValidator } from '@portal-workspace/grow-ui-library';
import { tap, delay, distinctUntilChanged } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { MARK, Mark } from '@portal-workspace/grow-ui-library/mark';
import {
  createNameInputMask,
  createNameIncludeDigitsInputMask,
} from '@portal-workspace/grow-ui-library';
import { AbstractControlValueAccessor } from '../abstract-control-value-accessor';
import {compareMatch, NameComponentValue, removeUnprintableCharFromName} from '@portal-workspace/grow-shared-library';
import { InputMaskModule } from '@ngneat/input-mask';
import { MatInputModule } from '@angular/material/input';

import { MatFormFieldModule } from '@angular/material/form-field';
import {DisableControlDirective} from '../../directives/disable-control.directive';

@UntilDestroy()
@Component({
    selector: 'name',
    templateUrl: './name.component.html',
    styleUrls: ['./name.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => NameComponent), multi: true },
        { provide: MARK, useExisting: forwardRef(() => NameComponent) },
    ],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, InputMaskModule, DisableControlDirective]
})
export class NameComponent extends AbstractControlValueAccessor<NameComponentValue> implements OnInit, AfterContentChecked, Mark {

  errorKeys = formControlErrorKeys;
  errorMessage = formControlErrorMessage;

  @Input({required: false}) placeholder = 'Enter name...';
  @Input({required: false}) title = 'Name';
  @Input({required: false}) includeDigits = false;
  @Input({required: false}) maxLength: number | null = null;

  formControl!: FormControl<NameComponentValue>;
  createNameInputMask = createNameInputMask();
  createNameIncludeDigitsInputMask = createNameIncludeDigitsInputMask();
  @Input({required: false}) mandatory = true;
  formGroup!: FormGroup<{
    name: FormControl<NameComponentValue>
  }>;
  subscription?: Subscription;

  constructor(private formBuilder: FormBuilder,
              private cdr: ChangeDetectorRef,) {
    super();
  }

  ngOnInit(): void {
    setupUntilDestroy(this);
    this.formControl = this.formBuilder.control('', this.mandatory ? [Validators.required,noSpaceValidator()] : []);
    this.formGroup = this.formBuilder.group({
      name: this.formControl,
    });
    this.subscription = this.formControl.valueChanges.pipe(
      delay(0),
      distinctUntilChanged(compareMatch),
      tap((v: any) => {
        if (this.formGroup.valid || this.formGroup.disabled) {
          // remove unprintable characters and remove front & end spaces, keeping accented letters
          // (ADO-817) that createNameInputMask allows through
          this.propagateChange(removeUnprintableCharFromName(v));
        } else {
          this.propagateChange(null)
        }
      })
    ).subscribe();
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  doWriteValue(v: NameComponentValue) {
    this.formControl.setValue(v);
  }

  mark() {
    this.formControl.markAllAsTouched();
  }

}
